import React, { FC } from 'react';
import { Link } from '@okapi/router-react';
import { VariantsAxisModel, Product } from 'features/variants';
import { Carousel, CarouselItem } from 'common/components/carousel';
import { VariantItem } from 'common/components/product-variants/variant-item';
import { VariantImage, VariantImageDataProps } from 'common/components/product-variants/variant-image';
import { useSelector } from 'react-redux';
import { isMainInfoLoading } from 'features/product-info/ducks/selectors';
import { jcm } from 'utils';
import { sortAxis } from 'features/product-info/components/pdp-variants/utils';
import { AxisPoint } from 'features/product-info/components/pdp-variants/types';
import { carouselContainer, carouselItem, imageOfPuncturePoint, variantItem } from './styles';

export const DATA_QA_VARIANT_CAROUSEL = 'pdp-variant-carousel';
export const DATA_QA_VARIANT_CAROUSEL_ITEM = 'pdp-variant-carousel-item';

type Props = {
  variantsModel: VariantsAxisModel[];
  activePoint?: Product;
  onVariantClick: (ap: AxisPoint) => void;
};
export const ColorCarousel: FC<Props> = ({ variantsModel, activePoint, onVariantClick }) => {
  const mainInfoLoading = useSelector(isMainInfoLoading);

  const { pointsOnAxis, asImageThumb } = variantsModel
    ? variantsModel[0]
    : { pointsOnAxis: [], asImageThumb: false };
  const sortedAxis = sortAxis(pointsOnAxis);

  return (
    <Carousel className={carouselContainer} dataQa={DATA_QA_VARIANT_CAROUSEL}>
      {sortedAxis.map((ap) => {
        const isPuncturedPoint = !!ap.isPuncturedPoint;
        const pointKey = ap.toProductUrl;
        const isActive = pointKey === activePoint?.productLink || false;
        const imageClasses = {
          [imageOfPuncturePoint]: isPuncturedPoint,
        };
        const itemProps: AxisPoint & {
          ref?: ((instance: HTMLDivElement | null) => void) | React.RefObject<HTMLDivElement> | null;
        } = { ...ap };
        return (
          <CarouselItem
            key={ap?.label}
            className={carouselItem}
            onClick={() => onVariantClick(ap)}
            data-qa={DATA_QA_VARIANT_CAROUSEL_ITEM}
          >
            <VariantItem
              {...itemProps}
              className={variantItem}
              ProductLinkComponent={Link}
              asImageThumb={asImageThumb}
              active={isActive}
              disabled={mainInfoLoading}
              inactive={isPuncturedPoint}
            >
              <VariantImage className={jcm(imageClasses)} {...(ap as VariantImageDataProps)} />
            </VariantItem>
          </CarouselItem>
        );
      })}
    </Carousel>
  );
};
